"use client"

import { useEffect, useState } from "react"
import type { AuthModalContext } from "@/shared/stores/ui-store"
import { subscribeToMediaQuery } from "@/shared/lib/media-query"

type SidebarComponent = typeof import("./sidebar").Sidebar

interface ResponsiveSidebarProps {
  authModalContext?: AuthModalContext | null
}

/** Keeps desktop-only navigation and its dialogs out of mobile entry bundles. */
export function ResponsiveSidebar({
  authModalContext = null,
}: ResponsiveSidebarProps) {
  const [Sidebar, setSidebar] = useState<SidebarComponent | null>(null)

  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)")
    let cancelled = false

    const sync = () => {
      if (!media.matches) {
        setSidebar(null)
        return
      }

      void import("./sidebar").then((module) => {
        if (!cancelled && media.matches) {
          setSidebar(() => module.Sidebar)
        }
      })
    }

    sync()
    const unsubscribe = subscribeToMediaQuery(media, sync)
    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [])

  return Sidebar ? <Sidebar authModalContext={authModalContext} /> : null
}
